module.exports = __webpack_public_path__ + "static/media/singlechoice.8272d722.svg";